import { useTranslation } from "react-i18next";
import { useEnumeration } from "../../../../common/api/queries";
import { InstitutionBase } from "../../../institution/types";
import { EnumerationType } from "../../enums";

interface Props {
  institution: InstitutionBase;
  hideDeactivatedLabel?: boolean;
}

export const InstitutionEnumName = ({ institution, hideDeactivatedLabel }: Props) => {
  const { t } = useTranslation();

  const institutionsEnums = useEnumeration(EnumerationType.INSTITUTIONS);

  return institution ? (
    !hideDeactivatedLabel && institutionsEnums.find((i) => i.id === institution.id)?.deactivated ? (
      <span>{`${institution.name} (${t("institution.helpers.deactivated")})`}</span>
    ) : (
      <span>{institution.name}</span>
    )
  ) : null;
};
